// @flow
import React, { Component } from 'react'
import { calcImpliedVolatility } from '../../services/risk'
import { StyledRow } from './style'
import { Card, Form, Input, Button, Select, Col } from 'antd'
const FormItem = Form.Item
const Option = Select.Option

type Props = {
  form: Form
}

type State = {
  form: {
    optionType: string,
    assetPrice: string,
    strikePrice: string,
    expireDay: string,
    riskFree: string,
    dividendYield: string,
    marketPrice: string,
    volatility: string
  }
}

const initialState: State = {
  form: {
    optionType: 'call',
    assetPrice: '0',
    strikePrice: '0',
    expireDay: '0',
    riskFree: '0',
    dividendYield: '0',
    marketPrice: '0',
    volatility: '0%'
  }
}

class VolatilityForm extends Component<Props, State> {

  state: State = {
    form: {
      optionType: initialState.form.optionType,
      assetPrice: initialState.form.assetPrice,
      strikePrice: initialState.form.strikePrice,
      expireDay: initialState.form.expireDay,
      riskFree: initialState.form.riskFree,
      dividendYield: initialState.form.dividendYield,
      marketPrice: initialState.form.marketPrice,
      volatility: initialState.form.volatility
    }
  }

  handleSubmit = (e: Object) => {

    e.preventDefault()

    this.props.form.validateFields((err, values) => {
      if (!err) {
        
        // calculate IV
        const volatility: Object = calcImpliedVolatility(values)

        // update IV
        const form: Form = { ...this.state.form }
        form.volatility = volatility.volatility

        this.setState({ form })
      }
    })
  }

  handleReset = () => {

    // reset to initial state
    this.setState({ form: initialState.form })
    this.props.form.resetFields()
  }

  render() {

    // --- Props and State ---
    const { getFieldDecorator } = this.props.form
    const { form } = this.state

    // --- Input Layout
    const formItemLayout: Object = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      }
    }

    return (
      <Card bordered={false} title='Implied Volatility'>

        <Form onSubmit={this.handleSubmit}>

          <FormItem {...formItemLayout} label='Option Type'>
            {getFieldDecorator('optionType', {
              initialValue: form.optionType,
              rules: []
            })( 
              <Select> 
                <Option value='call'>Call</Option>
                <Option value='put'>Put</Option>
              </Select>
            )}
          </FormItem>

          <FormItem {...formItemLayout} label='Asset Price'> 
            {getFieldDecorator('assetPrice', {
              initialValue: form.assetPrice,
              rules: []
            })( <Input  /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Strike Price'>
            {getFieldDecorator('strikePrice', {
              initialValue: form.strikePrice,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Expiration'> 
            {getFieldDecorator('expireDay', {
              initialValue: form.expireDay,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Risk Free Rate'>
            {getFieldDecorator('riskFree', {
              initialValue: form.riskFree,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Dividend Yield'> 
            {getFieldDecorator('dividendYield', {
              initialValue: form.dividendYield,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Market Price'>
            {getFieldDecorator('marketPrice', {
              initialValue: form.marketPrice,
              rules: []
            })( <Input /> )}
          </FormItem>

          <FormItem {...formItemLayout} label='Implied Volatility'>
            {getFieldDecorator('volatility', {
              initialValue: form.volatility,
              rules: []
            })( <Input disabled /> )}
          </FormItem>

          <StyledRow gutter={8}>
            <Col span={10} offset={2}>
              <FormItem>
                <Button type='primary' htmlType='submit'>
                  Calculate
                </Button>
              </FormItem>
            </Col>

            <Col span={10}>
              <FormItem>
                <Button onClick={this.handleReset}>
                  Reset
                </Button>
              </FormItem>
            </Col>
          </StyledRow>

        </Form>
      </Card>
    )
  }
}

const CalculatorVolatility = Form.create()(VolatilityForm)
export default CalculatorVolatility



// WEBPACK FOOTER //
// ./src/components/form-calculator-volatility/index.js